import { Link } from "react-router-dom";
import RequireCompany from "@/components/RequireCompany";
import PageHeader from "@/components/PageHeader";
import { Users, CalendarCheck2, ReceiptIndianRupee } from "lucide-react";

const tiles = [
  {
    to: "/payroll/employees",
    title: "Employees",
    desc: "Add and maintain employee master with statutory details (PAN, PF UAN, ESI, bank).",
    icon: Users,
    testid: "payroll-tile-employees",
  },
  {
    to: "/payroll/pay-run",
    title: "Pay Run",
    desc: "Monthly salary processing — LOP, statutory deductions, auto-post Journal voucher.",
    icon: CalendarCheck2,
    testid: "payroll-tile-payrun",
  },
  {
    to: "/payroll/payslips",
    title: "Payslips",
    desc: "Generated payslips by month with PDF / print download.",
    icon: ReceiptIndianRupee,
    testid: "payroll-tile-payslips",
  },
];

function Inner() {
  return (
    <>
      <PageHeader title="Payroll" subtitle="Employees, monthly pay-run, statutory deductions, payslips" />
      <div className="p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl" data-testid="payroll-index">
          {tiles.map((t) => (
            <Link key={t.to} to={t.to} className="block border border-gray-200 rounded bg-white p-5 hover:border-blue-400 hover:shadow-sm transition group" data-testid={t.testid}>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded bg-blue-50 text-blue-700 flex items-center justify-center group-hover:bg-blue-100">
                  <t.icon className="w-5 h-5" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm">{t.title}</div>
                  <div className="text-xs text-gray-500 mt-1">{t.desc}</div>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-6 text-xs text-gray-500 max-w-3xl">
          Statutory rules applied: <span className="font-mono">PF = 12% of Basic (cap ₹15,000 → max ₹1,800), ESI = 0.75% of Gross when Gross ≤ ₹21,000, Professional Tax = ₹200/mo (Maharashtra), TDS = manual per employee.</span>
        </div>
      </div>
    </>
  );
}

export default function Payroll() {
  return (
    <RequireCompany>
      <Inner />
    </RequireCompany>
  );
}
